const PAYMENT_LABELS = {
  CASH: 'Dinheiro',
  CARD: 'Cartão',
  PIX: 'PIX',
  ONLINE: 'Pagamento virtual',
};

const MP_METHOD_LABELS = {
  pix: 'PIX',
  master: 'Mastercard',
  visa: 'Visa',
  amex: 'Amex',
  elo: 'Elo',
  hipercard: 'Hipercard',
};

export function getPaymentLabel(payment) {
  return PAYMENT_LABELS[payment] || payment;
}

export function getMpMethodLabel(method) {
  if (!method) return null;
  return MP_METHOD_LABELS[method] || method.toUpperCase();
}

export function isOnlinePayment(order) {
  return order?.payment === 'ONLINE';
}

export function isOrderPaid(order) {
  return !!order?.paidAt;
}
